module.exports = __webpack_public_path__ + "img/BNB.1aa88810.svg";